import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { UPDATE_USER_POSITION } from '../constants/constants';
import NoSleep from 'nosleep.js';

const defaultSettings = {
  enableHighAccuracy: false,
  timeout: Infinity,
  maximumAge: 0,
};
const geolocation = navigator && navigator.geolocation;

const usePosition = (userSettings = {}) => {

  const settings = {
    ...defaultSettings,
    ...userSettings,
  };
  const [error, setError] = useState('');
  const [position, setPosition] = useState({});
  const watchPositionId = useRef(null);
  const dispatch = useDispatch();
  const noSleep = new NoSleep();

  // Clears the watch instance based on the saved watch id
  const stopWatchPosition = () => {
    if (watchPositionId.current && geolocation) {
      console.log('[GEO] Arrêt de la prise de position');
      noSleep.disable();
      geolocation.clearWatch(watchPositionId.current);
      watchPositionId.current = 0;
      const myPosition = {};
      setPosition(myPosition);
      console.log(`[GEO] Position utilisateur = {Latitude: ${myPosition?.latitude}, Longitude: ${myPosition?.longitude}}`);
      dispatch({ type: UPDATE_USER_POSITION, payload: myPosition });
    }
  };

  const startWatchPosition = () => {
    if (!watchPositionId?.current && geolocation) {
      console.log('[GEO] Démarrage de la prise de position');
      noSleep.enable().then(() => {
        console.log(
          'Le navigateur ne dort jamais!'
        );
      });
      getPosition();
      watchPositionId.current = geolocation.watchPosition(handleSuccess, handleError, settings);
    }
  };

  const getPosition = () => {
    if (geolocation) {
      geolocation.getCurrentPosition(handleSuccess, handleError, settings);
    }
  };

  const handleSuccess = ({coords, timestamp}) => {
    const myPosition = {
      latitude: coords.latitude,
      longitude: coords.longitude,
      accuracy: coords.accuracy,
      speed: coords.speed,
      heading: coords.heading,
      timestamp,
    };
    setPosition(myPosition);
    console.log(`[GEO] Position utilisateur = {Latitude: ${myPosition?.latitude}, Longitude: ${myPosition?.longitude}}`);
    dispatch({ type: UPDATE_USER_POSITION, payload: myPosition });
  };

  const handleError = error => {
    setError(error.message);
    console.log('[GEO] error : ' + error.message);
  };

  useEffect(() => {
    if (!geolocation) {
      setError('La géolocalisation n\'est pas supportée par votre navigateur!');
      return;
    }
    console.log('[GEO] Interruption');
    return stopWatchPosition;
  }, [
    settings.enableHighAccuracy,
    settings.timeout,
    settings.maximumAge,
  ]);

  return { startWatchPosition, stopWatchPosition, getPosition };

};

export default usePosition;